"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const VinylWallMapDemonstration_1 = __importDefault(require("./VinylWallMapDemonstration"));
const VehicleMapDemonstration_1 = __importDefault(require("./VehicleMapDemonstration"));
const MatboardWallMapDemonstration_1 = __importDefault(require("./MatboardWallMapDemonstration"));
/*
 * Renders an SVG showing useful information about a design.
 */
function OutputTypeDemonstration(_a) {
    var { outputType } = _a, props = __rest(_a, ["outputType"]);
    switch (outputType) {
        case "VINYL_WALL_MAP":
            return (react_1.default.createElement(VinylWallMapDemonstration_1.default, Object.assign({}, Object.assign({ primaryColor: "#000000" }, props))));
        case "VEHICLE_MAP":
            return (react_1.default.createElement(VehicleMapDemonstration_1.default, Object.assign({}, Object.assign({ primaryColor: "#000000" }, props))));
        case "MATBOARD_WALL_MAP":
        case "MATBOARD_WALL_MAP_SINGLE":
            return (react_1.default.createElement(MatboardWallMapDemonstration_1.default, Object.assign({}, Object.assign({ primaryColor: "#000000" }, props))));
        default:
            return null;
    }
}
exports.default = OutputTypeDemonstration;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3V0cHV0VHlwZURlbW9uc3RyYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9vdXRwdXRUeXBlL091dHB1dFR5cGVEZW1vbnN0cmF0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsa0RBQTBCO0FBRTFCLDRGQUFvRTtBQUNwRSx3RkFBZ0U7QUFDaEUsa0dBQTBFO0FBRTFFOztHQUVHO0FBQ0gsU0FBd0IsdUJBQXVCLENBQUMsRUFHTDtRQUhLLEVBQzlDLFVBQVUsT0FFK0IsRUFEdEMsS0FBSyxjQUZzQyxjQUcvQyxDQURTO0lBRVIsUUFBUSxVQUFVLEVBQUU7UUFDbEIsS0FBSyxnQkFBZ0I7WUFDbkIsT0FBTyxDQUNMLDhCQUFDLG1DQUF5QixvQ0FBTyxZQUFZLEVBQUUsU0FBUyxJQUFLLEtBQUssR0FBTSxDQUN6RSxDQUFDO1FBQ0osS0FBSyxhQUFhO1lBQ2hCLE9BQU8sQ0FDTCw4QkFBQyxpQ0FBdUIsb0NBQU8sWUFBWSxFQUFFLFNBQVMsSUFBSyxLQUFLLEdBQU0sQ0FDdkUsQ0FBQztRQUNKLEtBQUssbUJBQW1CLENBQUM7UUFDekIsS0FBSywwQkFBMEI7WUFDN0IsT0FBTyxDQUNMLDhCQUFDLHNDQUE0QixvQ0FDckIsWUFBWSxFQUFFLFNBQVMsSUFBSyxLQUFLLEdBQ3ZDLENBQ0gsQ0FBQztRQUNKO1lBQ0UsT0FBTyxJQUFJLENBQUM7S0FDZjtBQUNILENBQUM7QUF2QkQsMENBdUJDIn0=